import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const advertiseImage = createAsyncThunk('advertiseImage', async () => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `advertise_list`,
            params:{
                "advertise_type ":'default'
            },
            headers: { "Content-Type": "application/json" }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const advertiseImageSlice = createSlice({
    name: 'advertiseImage',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(advertiseImage.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else {
                state.data = [];
            }
        });
        builder.addCase(advertiseImage.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default advertiseImageSlice.reducer; 